import { axiosInstanceProducts } from "./instance";

export const showTokenizationTransaction = (uuid) =>
  axiosInstanceProducts.get(`/tokenization/transaction/${uuid}`);
export const putTokenizationTransaction = (data = {}) =>
  axiosInstanceProducts.put("/tokenization/transaction", data);

export const uploadTokenizationCertificate = (data = {}) =>
  axiosInstanceProducts.post("/tokenization/certificate", data);
